<div class="card" [style.background-image]="'url(' + image() + ')'" [routerLink]="cardRoute()">
    <div class="card-overlay">
        @if (isDevelop) {
        <span class="debug-id">{{ OBJECTID() }}</span>
        }
        <span class="card-category">{{ categoriaLabel() | translate }}</span>
        <h3 class="card-title">{{ denominacion() }}</h3>
    </div>
</div>